import React from "react";
import { HomeScreen } from "./screens/index";
import { GlobalStyle } from "./styles/styles";

function App() {
  return (
    <>
      <GlobalStyle />
      <HomeScreen />
    </>
  );
}

export default App;
